export default "__VITE_ASSET__DmhpBYzd__"